import dynamic from 'next/dynamic';
import 'react-multi-carousel/lib/styles.css';
import Link from 'next/link';
import FAQ from '../components/FAQ';
import HowItWorks from '../components/HowItWorks';
import Button from '@mui/material/Button';
import DontWaitBannerSection from 'components/composed/sections/DontWaitBannerSection';
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import { isMobile } from 'react-device-detect';
import { NextSeo } from 'next-seo';
import { config } from '_config';
import { clearSessionValue } from '../_helpers/storage';
import {
  KEY_ORDER_AFTER_SUCCESS_PAYMENT,
  removeItemSessionStorage,
} from '../variables/Variables';
import Head from 'next/head';

const TrustPilotReview = dynamic(() =>
  import('../components/TrustPilotReview')
);
const { apiUrl } = config;

export default function TrademarkRegistrationPage() {
  const titleRef = useRef();
  const [productName, setProductName] = useState(null);
  const [productPrice, setProductPrice] = useState(null);
  function handleScrollClick() {
    if (titleRef?.current) {
      titleRef.current?.scrollIntoView();
    }
  }

  useEffect(() => {
    localStorage.removeItem('path');
    localStorage.removeItem('product');
    localStorage.removeItem('token');
    localStorage.removeItem('tokenDiscount');
    localStorage.removeItem('updated');
    clearSessionValue('orderParams');
    removeItemSessionStorage(KEY_ORDER_AFTER_SUCCESS_PAYMENT);
    let salePage = window.location.href;
    let salePageURLArr = salePage.split('/');
    let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
      /\/+$/,
      ''
    );
    let url = apiUrl + '/category/TRADEMARKS/products/prices';
    let fallbackUrl =
      `${salePageURL}/crm` + '/category/TRADEMARKS/products/prices';

    axios
      .get(url, {
        params: {
          onlyForSale: true,
          productCodes: 'TRADEMARK_RegisterTrademark',
          processingOptions: 'STANDARD',
        },
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          setProductName(response.data[0].code.customerName);
          setProductPrice(response.data[0].price);
        }
      })
      .catch((error) => {
        if (error.request) {
          axios
            .get(fallbackUrl, {
              params: {
                onlyForSale: true,
                productCodes: 'TRADEMARK_RegisterTrademark',
                processingOptions: 'STANDARD',
              },
              headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
              if (response.status === 200 && response.data.length > 0) {
                setProductName(response.data[0].code.customerName);
                setProductPrice(response.data[0].price);
              }
            });
        }
      });
  }, []);

  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          href="/register-trademark-banner-m.jpg"
          media="(max-width: 700px)"
          fetchpriority="high"
        />
      </Head>
      <div className="reg-trademark">
        <NextSeo title="Trademark Registration" />
        <div className="banner">
          <div className="copy-wrapper">
            <div className="copy">
              <h1>Register your name, slogan, or logo today.</h1>
              <p>
                Protect your name, logo or slogan now! We make the process
                quick, easy and simple for you to ensure proper filing.
              </p>
              <ul>
                <li>
                  <p>
                    <span></span>Protect your brand nationwide
                  </p>
                </li>
                <li>
                  <p>
                    <span></span>Enforce and defend your rights
                  </p>
                </li>
                <li>
                  <p>
                    <span></span>Full Preparation and Filing of your Official
                    Trademark with USPTO
                  </p>
                </li>
                <li>
                  <p>
                    <span></span>70% of Self Filers make a mistake, avoid that
                    today
                  </p>
                </li>
              </ul>
              <Link href="/registration-trademark">
                <a className="orange-btn">
                  Start My Trademark Registration Now
                </a>
              </Link>
              <Typography
                className="orange-btn"
                style={{ cursor: 'pointer' }}
                onClick={handleScrollClick}
              >
                Learn More
              </Typography>
              <Typography
                style={{
                  fontSize: '12px',
                  textAlign: 'center',
                  maxWidth: '320px',
                }}
              >
                Secure Your Brand in Just 3 Minutes
              </Typography>
            </div>
          </div>

          {isMobile ? <TrustPilotReview /> : ''}
        </div>
        <div>{isMobile ? '' : <TrustPilotReview />}</div>
        <HowItWorks onRef={titleRef} />

        <div className="sides desktop">
          <div className="sides-wrapper">
            <div className="left-side">
              <div className="side-box-wrapper">
                <div className="side-box-back-2"></div>
                <div className="side-box-back"></div>
                <div className="side-box">
                  <div className="header-line"></div>
                  <h4>Trademark Registration</h4>
                  <h5>Get your trademark fully registered</h5>
                  <div className="orange-box">
                    <div className="star"></div>
                    <div className="price-wrapper">
                      <div className="price">
                        {'$' + productPrice?.toFixed(2)}
                      </div>
                      <p>+ USPTO gov fees</p>
                    </div>
                    <div className="star"></div>
                  </div>
                  <ul>
                    <li>
                      <span></span>
                      <p>
                        Professional assembly, formatting and review done by
                        specialists
                      </p>
                    </li>
                    <li>
                      <span></span>
                      <p>Electronic delivery and transparent updates</p>
                    </li>
                    <li>
                      <span></span>
                      <p>All information secured and organized in one place</p>
                    </li>
                  </ul>
                  <Link href="/registration-trademark">
                    <Button>Start Now</Button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="right-side">
              <h3>Why get a trademark?</h3>
              <div className="right-side-body">
                There are numerous benefits of obtaining a trademark for your
                business name, logo, or slogan.
                <ul>
                  <li>Protect your brand & ideas</li>
                  <li>Gives legitimacy to Your Business</li>
                  <li>Adds value to your Business</li>
                  <li>Deters Competitors</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="sides mobile">
          <div className="sides-wrapper">
            <div className="right-side">
              <h3>Why get a trademark?</h3>
              <div className="right-side-body">
                There are numerous benefits of obtaining a trademark for your
                business name, logo, or slogan.
                <ul>
                  <li>Protect your brand & ideas</li>
                  <li>Gives legitimacy to Your Business</li>
                  <li>Adds value to your Business</li>
                  <li>Deters Competitors</li>
                </ul>
              </div>
            </div>
            <div className="left-side">
              <div className="side-box">
                <h4>Trademark Registration</h4>
                <h5>Get your trademark fully registered</h5>
                <div className="orange-box">
                  <div className="star"></div>
                  <div className="price-wrapper">
                    <div className="price">
                      {'$' + productPrice?.toFixed(2)}
                    </div>
                    <p>+ USPTO gov fees</p>
                  </div>
                  <div className="star"></div>
                </div>
                <ul>
                  <li>
                    <span></span>
                    <p>
                      Professional assembly, formatting and review done by
                      specialists
                    </p>
                  </li>
                  <li>
                    <span></span>
                    <p>Electronic delivery and transparent updates</p>
                  </li>
                  <li>
                    <span></span>
                    <p>All information secured and organized in one place</p>
                  </li>
                </ul>
                <Link href="/registration-trademark">
                  <Button>Start Now</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <FAQ leftSide={true} />

        <DontWaitBannerSection link="/registration-trademark" />
      </div>
    </>
  );
}
